// eslint-disable-next-line max-len
export const domainValidatorRegExp = /^(([a-zA-Z\d]{1,63}\.)|([a-zA-Z\d][a-zA-Z\d-]{0,61}[a-zA-Z\d]\.))+[a-zA-Z]{2,6}$/;

const validateDomain = (string: string): boolean => domainValidatorRegExp.test(string);

export default validateDomain;
